import * as React from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table-6'
import 'react-table-6/react-table.css'
import * as controller from '../car/controller'

export default class Cars extends React.Component<any, any> {
  searchString: any

  constructor(props: any) {
    super(props);
    this.state = {
      cars: [],
      carsFiltered: []
    }
  }

  search() {
      let carsFiltered = this.state.carsFiltered
      carsFiltered = this.state.cars.filter((car: any) => {
        return car.name.toLowerCase().includes(this.searchString.value.trim().toLowerCase())
      })
      this.setState({carsFiltered})
  }

  loadCars() {
    fetch('cars/getAll', {
      method: 'POST'
    }).then(results => {
      return results.json();
    }).then(data => {
        let cars = data.cars
        this.setState({cars, carsFiltered: cars})
    }).catch(err => {
      //alert(err.message);
    })
  }

  componentDidMount() {

  }

  componentWillMount() {
    this.loadCars()
  }

  componentWillUnmount() {
  }


  public render() {
    const columns = [{
      Header: 'Model',
      accessor: 'name'
    }, {
      Header: 'Type',
      accessor: 'type'
    }, {
      id: 'settings',
      Header: 'Settings',
      sortable: false,
      maxWidth: 100,
      resizable: false,
      accessor: (d:any) => d,
      Cell: (row:any) => <div>
        <Link to={"/cars/" + row.value.id}><i className="fas fa-edit"></i></Link>
        <i onClick={controller.removeCar.bind(this, row.value.id, row.index)} className="fas fa-trash-alt"></i>
      </div>
    }]

    return (
      <div id="users-root">
        <input className="search" type="text" placeholder="Search vehicle by model" onChange={this.search.bind(this)} ref={(searchString:any) => this.searchString = searchString} />

        <div className="board">
          <ReactTable
            data={this.state.carsFiltered}
            columns={columns}
            noDataText="No vehicles found"
            pageSizeOptions={[100,300,500,1000]}
            defaultPageSize={100}
            style={{
              height: "calc(100vh - 120px)",
              textAlign: "center",
              fontSize: "1em",
              position: "centner",
              right: "0",
              left: "0",
              margin: "0 auto"
            }}
            className="-striped -highlight reactTable"
          />
        </div>
      </div>
    )
  }

}
